import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Search model for Category
 */
@Injectable()
export class CategorySimpleSearchModel extends SearchModel<any> {
    static readonly MAX_LEVEL_FILTER_NAME: string = "maxLevel";

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "categoryId";
    }
}
